import { AccountService, cardDetail, loanDetail } from './../Services/account.service';
import { CommonService } from './../Services/common.service';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../Services/auth.service';
import { TopupServiceService } from '../Services/topup-service.service';
import { CookieService } from '../Services/cookie';
import { AmountFormatterPipe } from '../pipes/amount-formatter.pipe';



@Component({
  selector: "app-pay-card",
  templateUrl: "./pay-card.component.html",
  standalone:false,
  styleUrls: ["./pay-card.component.scss"],
})
export class PayCardComponent implements OnInit {
  selectedAmount: string = "";
  Amountlist;
  selectedMethod: string = "";
  internalId: string = "";
  Methodlist;
  AccountType: string = "";
  loanDetail: [];
  amount: any;
  CardDetail;
  LoanDetail;
  activeTab: number;
  decimalErro:boolean = false;

  flow: string;
  amountdetail: any;
  isInquire: boolean;
  Inquireamount: string;
  amountchnged: boolean = false;
  amountfixed: string;
  MAxPay: any;
  PinternalId: string;
  PAccountType: string;
  Pflow: string;
  PMAxPay: any;
  udF1: string;
  udF2: string;
  cardPay: string;

  constructor(
    private cookieService: CookieService, public topupservice: TopupServiceService,
    private route: ActivatedRoute,
    private _router: Router,
    private location: Location,
    public auth: AuthService,
    private commonP: CommonService,
    private topup: TopupServiceService,
    private account: AccountService, private _route: ActivatedRoute,
    private amountpipe: AmountFormatterPipe
  ) { }
  back() {
    this.location.back();
  }

  async ngOnInit(): Promise<void> {

    let Id =await this.cookieService.get("directCardpay", false);
    if (Id) {
      this.cardPay = Id;
      console.log(this.cardPay,"cards");
      
    }
    this._route.queryParams.subscribe(params => {
      if (params) {

        if (params['id']) {

          this.PinternalId = params['id'];
          this.PAccountType = params['type'];
          this.Pflow = params['flow'];
          this.PMAxPay = params['max'];
          this.internalId = params['id'];
          this.AccountType = params['type'];
          this.flow = params['flow'];
          this.MAxPay = params['max'];
console.log("yousuf",params);



        }
      }
    });
    if (this.Pflow == undefined || this.Pflow == "") {
      let a =await this.cookieService.get("flow", );

      if (a) {

        this.flow = a;

      }
    }
    if (this.PinternalId == undefined || this.PinternalId == "") {

      let Id =await this.cookieService.get("InternalId", true);
      if (Id) {
        this.internalId = Id;
      }
    }

    let d =await this.cookieService.get("amountdetail", true);

    if (d) {

      this.amountdetail = JSON.parse(d);
      console.log('amountdetail', this.amountdetail)

    }

    let i =await this.cookieService.get("isInquire", true);

    if (i) {

      this.isInquire = JSON.parse(i);

    }


    if (this.PAccountType == undefined || this.PAccountType == "") {
      let P =await this.cookieService.get("prodType", true);
      if (P) {
        this.AccountType = P;
      }
    }

    if (this.PMAxPay == undefined || this.PMAxPay == "") {
      let M =await this.cookieService.get("MaxPayment", true);
      if (M) {
        this.MAxPay = M;

      }
    }
     
    


    this.auth.accessToken = await this.commonP.Get("token");

    if (this.auth.detailuser) {
    // if (this.auth?.detailuser) {

    await this.commonP.presentLoading();
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {

      if (data?.response?.code == 1) {
        this.account.GetLoanDashboard(this.auth.accessToken).then((data: any) => {
          if (data?.response?.code == 1) {
            if (this.AccountType == "C") {
              console.log("yousufCards",this.AccountType);
              

              let CardDetail = data.response.content.cardDetails;
              this.CardDetail = CardDetail?.filter((x) => x.internalId == this.internalId);
              console.log("CardDetail", this.CardDetail);
              this.commonP.hideLoading();


            }
            else if (this.AccountType == "L") {
              console.log("yousufloans",this.AccountType);

              let LoanDetail = data.response.content.loanDetails;

              this.LoanDetail = LoanDetail?.filter((x) => x.internalId == this.internalId);
              console.log("LoanDetail", this.LoanDetail);
              this.commonP.hideLoading();


            }
          } else {
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
      }
      else {
        await this.commonP.hideLoading();
        if (this.flow != 'Quickpay') {
          this.commonP.ParseErrorAlert("", "", this._router, data);

        }
      }


    });
    // }
  } else {
    await this.commonP.hideLoading();
    console.log("No data then bhaag jao");
  }


  }



  onMethodChange(event) {
    //
    this.selectedMethod = event.displayValue;
    //
  }


  isValid() {

    //if( this.amount != null && parseInt(this.amount) != 0 && this.selectedMethod != "" && this.selectedMethod != null){
    let maxPaymntAmount = Number(this.MAxPay)
    // let A =this.amount != undefined && this.amount != 0 ? this.amount.toString().split('.'): "";

   
    if (this.amount != undefined && this.amount != 0 && (this.amount >= 5 && this.amount <= maxPaymntAmount) && this.decimalErro == false) {
      //
      // if(A.length > 1 && A[1].length == 3){

      //   this.decimalErro = false;
        return false;      
      // }
      // else if(A.length == 1){

      //   this.decimalErro = false;
      //   return false;      
      // }
      // else{

      //   this.decimalErro = true;
      //   return true;
      // }
    }
    else {
      //
      return true;
    }
  }

  selectPaymentMethod() {

    if (this.internalId != '' && this.internalId != null && (this.AccountType == 'C' || this.AccountType == 'L') && (this.flow == 'Pay' || this.flow == '' || this.flow == undefined)) {


      this.cookieService.set("InternalId", this.internalId.toString(),true);
      this.cookieService.set("amount", this.amount.toString(),true);
      if (this.flow != undefined) {
        this.cookieService.set("flow", this.flow.toString(),true);
      }
      this.cookieService.set("prodType", this.AccountType.toString(),true);
      this._router.navigateByUrl("/SelectPaymentMethod");

    }
    else {

      this.cookieService.set("amount", this.amount.toString(),true);
      this._router.navigateByUrl("/SelectPaymentMethod");

    }

  }

  ngModelChange(event) {

    if(this.flow == 'Quickpay')
{
event = event.toString();
}   
 this.amountchnged = false;

    let A =event != undefined && event != 0 ? event.toString().split('.'): "";
    if(A.length > 1 && A[1].length > 3){

      this.decimalErro = true;

    }
    else{
      this.decimalErro = false;
    }

    if (this.flow != 'Quickpay' && this.flow != 'Pay' && this.flow != 'Inquire') {

      if (event.length >= 1) {

        let n = this.amountpipe.transform(event.toString())

        this.amount = this.decimalErro == true ? event : Number(n);
        this.amountchnged = true;
        this.amountfixed = this.decimalErro == true ? event : n; 

      }
      else if (Number(event) < 0) {
        let n = this.amountpipe.transform(event.toString())

        this.amount = this.decimalErro == true ? event : Number(n);
        this.amountchnged = true;
        this.amountfixed = this.decimalErro == true ? event : n; 
      }
      else if (Number(event) >= 5) {
        let n = this.amountpipe.transform(event.toString())

        this.amount = this.decimalErro == true ? event : Number(n);
        this.amountchnged = true;
        this.amountfixed = this.decimalErro == true ? event : n; 
      }
    }
    else if (this.flow != 'Quickpay' && this.flow != 'Pay') {

      let n = this.amountpipe.transform(event.toString())
      this.amount = this.decimalErro == true ? event : Number(n);
      this.Inquireamount = this.decimalErro == true ? event : n; 

    }
    else {

      if (event.length >= 1) {

        let n = this.amountpipe.transform(event.toString())

        this.amount =this.decimalErro == true ? event :  Number(n);
        this.amountchnged = true;
        this.amountfixed = this.decimalErro == true ? event : n; 

      }

    }
  }

  applyFormatting(event: string) {
    let n = this.amountpipe.transform(event.toString());
    this.amount = this.decimalErro ? parseFloat(event) : parseFloat(n);
    this.amountfixed = this.decimalErro ? event : n;
    this.Inquireamount = this.decimalErro == true ? event : n;
    // let l = this.amountpipe.transform(event.toString())

    // this.amountfixed = this.decimalErro == true ? event : l; 
  }
  
  onBlur(event: any) {
    let value = event.target.value;
    this.applyFormatting(value);
  }

// quiqPay

quickApplyFormatting(event: string) {
  let n = this.amountpipe.transform(event.toString());
  this.amount = this.decimalErro ? parseFloat(event) : parseFloat(n);
  this.amountfixed = this.decimalErro ? event : n;
  this.amount = this.decimalErro == true ? event : n;
  // let l = this.amountpipe.transform(event.toString())

  // this.amountfixed = this.decimalErro == true ? event : l; 
}

quickOnblur(event: any) {
  let value = event.target.value;
  this.quickApplyFormatting(value);
}

  onAmountChange(eve, target) {

    this.activeTab = eve;
    if (eve == 1) {
      this.amount = Number(this.CardDetail[0]?.outstandingAmount);
      if (this.amount < 0 || this.amount == 0) {
        this.activeTab = 0;
        target.srcElement.checked = true;
      }
      this.ngModelChange(this.amount)
    }
    if (eve == 2) {
      this.amount = Number(this.CardDetail[0]?.lastStatementRemAmount);
      if (this.amount < 0 || this.amount == 0) {
        this.activeTab = 0;
        target.srcElement.checked = true;

      }
      this.ngModelChange(this.amount)
    }
    if (eve == 3) {

      this.amount = Number(this.CardDetail[0]?.minimumAmountDue);
      if (this.amount < 0 || this.amount == 0) {

        this.activeTab = 0;
        target.srcElement.checked = true;


      }
      this.ngModelChange(this.amount)
    }
  }





  changeLoanTab(l) {
    this.activeTab = l;
    if (l == 1) {

      this.amount = Number(this.LoanDetail[0]?.installmentAmount);
      if (this.amount < 0 || this.amount == 0) {
        this.activeTab = 0;
      }
      this.ngModelChange(this.amount)

    }
    if (l == 2) {
      this.amount = Number(this.LoanDetail[0]?.overdueAmount);
      if (this.amount < 0 || this.amount == 0) {
        this.activeTab = 0;
      }
      this.ngModelChange(this.amount)

    }
  }
  back2(){

    if (this.PAccountType === 'C') {
      this._router.navigateByUrl('/DashboardCreditCards');
    } else if (this.PAccountType === 'L') {
      this._router.navigateByUrl('/DashboardLoans');
    }
    else if (this.AccountType === 'C') {
      this._router.navigateByUrl('/Dashboard');
    }
    else if (this.AccountType === 'L') {
      this._router.navigateByUrl('/Dashboard');
    }
   

  }

  back3(){

 if (this.cardPay === 'directcard') {
      // this._router.navigateByUrl('/TypeOfPay');
      this.location.back();
    }
    else{
      
    }
  }

  changeTab(e) {

    this.activeTab = e;

    if (e == 1) {

      this.amount = Number(this.amountdetail?.outStandingAmount);
      if (this.amount < 0 || this.amount == 0) {
        this.activeTab = 0;
      }
      this.ngModelChange(this.amount)

    }
    if (e == 2) {
      this.amount = Number(this.amountdetail?.lastStatementRemAmount);
      if (this.amount < 0 || this.amount == 0) {
        this.activeTab = 0;
      }
      this.ngModelChange(this.amount)

    }
    if (e == 3) {
      this.amount = Number(this.amountdetail?.minimumAmount);
      if (this.amount < 0 || this.amount == 0) {
        this.activeTab = 0;
      }
      this.ngModelChange(this.amount)

    }

  }


  keypress = (e: KeyboardEvent) =>{

    console.log("onkeypress",e);

    //  ["e", "E", "+", "-", ".", ","].includes(e.key) && e.defaultPrevented;
     ["e", "E", "+", "-", ".", ","].includes(e.key) && e.preventDefault();

    }
}